import React from 'react'

const Manual_config_impuestos = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Configuraciones - Impuestos
        </h2>
        <iframe
          src="https://scribehow.com/embed/Configuraciones__Impuestos__sKK3a0q6SN2-dT0cOPaPcg?as=scrollable"
          className="scribe-iframe-general-164"
          width="100%"
          height="4300"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_config_impuestos
